import instance from "../utils/api_instance.util";

export const fetchSubscriptionListAPI = async (payload) => {
    try {
        const { data } = await instance.post('/api/v1/admin/subscription/getAllSubscriptions', { ...payload });
        return data;
    } catch (err) {
        throw err;
    }
}

export const createSubscriptionAPI = async (payload) => {
    try {
        const { data } = await instance.post('/api/v1/admin/subscription/createSubscription', { ...payload });
        return data;
    } catch (err) {
        throw err;
    }
}

export const fetchSubscriptionDataByIdAPI = async (payload) => {
    try {
        const { data } = await instance.post('/api/v1/admin/subscription/getSubscriptionById', { ...payload });
        return data;
    } catch (err) {
        throw err;
    }
}

export const updateSubscriptionAPI = async (payload) => {
    try {
        const { data } = await instance.post('/api/v1/admin/subscription/updateSubscription', { ...payload });
        return data;
    } catch (err) {
        throw err;
    }
}

export const updateSubscriptionStatusAPI = async (payload) => {
    try {
        const { data } = await instance.post('/api/v1/admin/subscription/updateSubscriptionStatus', { ...payload });
        return data;
    } catch (err) {
        throw err;
    }
}

export const makeDefaultSubscriptionAPI = async (payload) => {
    try {
        const { data } = await instance.post('/api/v1/admin/subscription/setDefaultPlan', { ...payload });
        return data;
    } catch (err) {
        throw err;
    }
}

export const getUserSubscriptionPlanAPI = async (payload) => {
    try {
        const { data } = await instance.post('/api/v1/admin/subscription/getUsersWithSubscriptions', { ...payload });
        return data;
    } catch (err) {
        throw err;
    }
}

export const getUserSubscriptionPlanHistory = async (payload) => {
    try {
        const { data } = await instance.post('/api/v1/admin/subscription/fetchSubscriptionByUserId', { ...payload });
        return data;
    } catch (err) {
        throw err;
    }
}

export const assignFreeSubscriptionAPI = async (payload) => {
    try {
        const { data } = await instance.post('/api/v1/admin/subscription/assignFreeSubscription', { ...payload });
        return data;
    } catch (err) {
        throw err;
    }
}



export const createSubscriptionPermission = async (payload) => {
    try {
        const { data } = await instance.post('/api/v1/admin/subscription/createSubscriptionPermission', { ...payload });
        return data;
    } catch (err) {
        throw err;
    }
}

export const getSubscriptionPermissionDetails = async (payload) => {
    try {
        const { data } = await instance.post('/api/v1/admin/subscription/getSubscriptionPermissionDetails', { ...payload });
        return data;
    } catch (err) {
        throw err;
    }
}

export const fetchTopupListAPI = async (payload) => {
    try {
        const { data } = await instance.post('/api/v1/admin/subscription/getAllTopups', { ...payload });
        return data;
    } catch (err) {
        throw err;
    }
}

export const createTopupAPI = async (payload) => {
    try {
        const { data } = await instance.post('/api/v1/admin/subscription/createTopup', { ...payload });
        return data;
    } catch (err) {
        throw err;
    }
}

export const updateTopupAPI = async (payload) => {
    try {
        const { data } = await instance.post('/api/v1/admin/subscription/updateTopup', { ...payload });
        return data;
    } catch (err) {
        throw err;
    }
}

export const updateTopupStatusAPI = async (payload) => {
    try {
        const { data } = await instance.post('/api/v1/admin/subscription/updateTopupStatus', { ...payload });
        return data;
    } catch (err) {
        throw err;
    }
}
